import StoredLayout from '../../layouts/StoredLayout'
import BarChartWidgets from './BarChartWidgets'
export default StoredLayout(BarChartWidgets)
